import { Account } from '@syf-api-library/credit-accounts'
import isAccountTypeSetpayOrPaylater from './isAccountTypeSetpayOrPaylater'

const hasOnlySetpayOrPaylaterAccounts = (accounts: Account[]) => {
  return accounts.every((account) =>
    isAccountTypeSetpayOrPaylater(account.product.type)
  )
}

export default hasOnlySetpayOrPaylaterAccounts
